import {
  POST_NEW_PARTICIPANT_SUCCESS,
  POST_NEW_PARTICIPANT_FAIL,
  GET_PARTICIPANTS_SUCCESS,
  GET_PARTICIPANTS_FAIL,
  GET_PARTICIPANT_DETAIL_SUCCESS,
  GET_PARTICIPANT_DETAIL_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  POST_PARTICIPANT_DOC_SUCCESS,
  POST_PARTICIPANT_DOC_FAIL,
  POST_UPDATE_PARTICIPANT_SUCCESS,
  POST_UPDATE_PARTICIPANT_FAIL,
  GET_PARTICIPANT_DOC_FAIL,
  GET_PARTICIPANT_DOC_SUCCESS,
  UPDATE_PARTICIPANT_PIC_FAIL,
  UPDATE_PARTICIPANT_PIC_SUCCESS,
  SHOW_HIDE_DOC,
  SHOW_HIDE_DOC_FAIL,
  SHOW_HIDE_DOC_SUCCESS,
  PARTICIPANT_CALENDER_DATA_FAIL,
  PARTICIPANT_CALENDER_DATA_SUCCESS,
  SET_PART_STATE_FAIL,
  SET_PART_STATE_SUCCESS,
  DELETE_DOC_SUCCESS,
  DELETE_DOC_FAIL,
  DELETE_DOC,
  DELETE_DESCRIPTION_SUCCESS,
  DELETE_DESCRIPTION_FAIL,
  PARTICIPANTS_LOCATION_ASSIGNEES_SUCCESS,
  PARTICIPANTS_LOCATION_ASSIGNEES_FAIL,
  PARTICIPANT_DETAILS_FOR_TASK_SUCCESS,
  PARTICIPANT_DETAILS_FOR_TASK_FAIL,
  PARTICIPANT_STATUS_HISTORY_SUCCESS,
  PARTICIPANT_STATUS_HISTORY_FAIL,
  ADD_REMARK_ON_STATUS_SUCCESS,
  ADD_REMARK_ON_STATUS_FAIL,
  GET_MYNDIS_GOAL_FAIL,
  GET_MYNDIS_GOAL_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  error: [],
  userData: [],
  userDetail: [],
  succRes: [],
  deletUser: [],
  docs: [],
  pic_update: [],
  add_update_res: [],
  doc_upload: [],
  partEvents: [],
  stateRes: [],
  loading: false,
  employees: [],
  details: [],
  statusLogs: [],
  ndisGoalList: [],
};

const Participant = (state = INIT_STATE, action) => {
  switch (action.type) {
    case PARTICIPANT_DETAILS_FOR_TASK_SUCCESS:
      return {
        ...state,
        details: action.payload,
      };

    case PARTICIPANT_DETAILS_FOR_TASK_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_REMARK_ON_STATUS_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case ADD_REMARK_ON_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case PARTICIPANT_STATUS_HISTORY_SUCCESS:
      return {
        ...state,
        statusLogs: action.payload,
      };

    case PARTICIPANT_STATUS_HISTORY_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case PARTICIPANTS_LOCATION_ASSIGNEES_SUCCESS:
      return {
        ...state,
        employees: action.payload,
      };

    case PARTICIPANTS_LOCATION_ASSIGNEES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_DESCRIPTION_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case DELETE_DESCRIPTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_DOC_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case DELETE_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SET_PART_STATE_SUCCESS:
      return {
        ...state,
        stateRes: action.payload,
      };

    case SET_PART_STATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SHOW_HIDE_DOC:
      return {
        ...state,
        doc_upload: [],
      };
    case SHOW_HIDE_DOC_SUCCESS:
      return {
        ...state,
        doc_upload: action.payload,
      };

    case SHOW_HIDE_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case PARTICIPANT_CALENDER_DATA_SUCCESS:
      return {
        ...state,
        partEvents: action.payload,
      };

    case PARTICIPANT_CALENDER_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_PARTICIPANT_PIC_SUCCESS:
      return {
        ...state,
        pic_update: action.payload,
      };

    case UPDATE_PARTICIPANT_PIC_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_PARTICIPANT_DOC_SUCCESS:
      return {
        ...state,
        docs: action.payload,
      };

    case GET_PARTICIPANT_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        userData: action.payload,
        pic_update: [],
      };

    case GET_PARTICIPANTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case POST_NEW_PARTICIPANT_SUCCESS:
      return {
        ...state,
        add_update_res: action.payload,
        pic_update: [],
      };

    case POST_NEW_PARTICIPANT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case POST_UPDATE_PARTICIPANT_SUCCESS:
      return {
        ...state,
        add_update_res: action.payload,
        pic_update: [],
      };

    case POST_UPDATE_PARTICIPANT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PARTICIPANT_DETAIL_SUCCESS:
      return {
        ...state,
        userDetail: action.payload,
        pic_update: [],
      };

    case GET_PARTICIPANT_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        deletUser: action.payload,
        pic_update: [],
      };

    case DELETE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case POST_PARTICIPANT_DOC_SUCCESS:
      return {
        ...state,
        doc_upload: action.payload,
      };

    case POST_PARTICIPANT_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MYNDIS_GOAL_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MYNDIS_GOAL_SUCCESS:
      return {
        ...state,
        ndisGoalList: action.payload,
      };

    default:
      return state;
  }
};

export default Participant;
